import { useMemo } from 'react';

import { FamilyEvent } from '@/features/guardian/family-events';
import { useGuardianPlayersQuery } from '@/features/guardian/queries';
import { useSessionStore } from '@/stores/session-store';

/**
 * The guardian's linked players plus their family schedule.
 *
 * Players come from the API; the events are still mocked, but they are generated from
 * those players (see `buildFamilyEvents`) so the Kids tab and the Calendar screen always
 * show the kids actually on the account.
 */
export function useFamilyEvents() {
  const uid = useSessionStore(s => s.user?.uid);
  const { data, isLoading, refetch } = useGuardianPlayersQuery(uid);

  const players = useMemo(() => data ?? [], [data]);
  // const events = useMemo(() => buildFamilyEvents(players), [players]);
  const events: FamilyEvent[] = useMemo(() => [], []);

  return { players, events, isLoading, refetch };
}
